import $ from 'jquery';
import { trace } from 'rytm-helpers'
import Gallery from "blueimp-gallery";
import { updateLinks } from './linksFix'
import { affixFafix, updateAffix } from './affix-fafix'
import { TweenMax, TimelineMax, Power0, Power1, Power2, Power3, Power4, Back, Bounce, Elastic, Expo, Sine } from 'gsap'


// ### Window update
export const windowUpdate = (e) => {
  updateLinks()
  updateAffix()
};

// BlueImp Gallery click
const onBlueimpGalleryLinkClick = (e) => {
  e.preventDefault();
  let blueimpLinks = document.querySelectorAll('[data-gallery]');  
  let selector = e.currentTarget.getAttribute('data-gallery');
  trace("blueimp gallery selector", selector)
  if (!selector) {
    return
  }
  let link = e.currentTarget;
  let options = {
    container: selector,
    event: e,
    index: link,
    titleElement: 'header'
  }
  Gallery(blueimpLinks, options);
}
export const blueimpGalleryDestroy = () => {
  document.body.style.overflow = "visible"
}


export const removeReCaptchaBadge = () => {
  const list = [...document.querySelectorAll(".grecaptcha-badge")]
  list.forEach((el) => {
    const parentDiv = el.parentNode
    parentDiv.removeChild(el)
    // remove DIV
    parentDiv.parentNode.removeChild(parentDiv)
  })
}
const scrollSpeed = 8000 // PX/sec
const scrollTimeOffset = 1 // PX/sec
// # get anchor link target element
const getAnchorLinkTarget = (trigger) => {
  const targetSelector = trigger.getAttribute("href")
  if (targetSelector) {
    const id = targetSelector.substring(1)
    return document.getElementById(id)
  }
}
// # Distance (PX) to target
const getDistanceToTarget = (target) => {
  const targetTop = target.offsetTop
  return Math.round(Math.abs(window.pageYOffset - targetTop))
}
// # Time of scroll to target animation
const getScrollToTargetTime = (target) => {
  const distance = getDistanceToTarget(target)
  return scrollTimeOffset + distance / scrollSpeed
}
const getWindowScrollTop = () => {
  const doc = document.documentElement
  return (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0)
}
const getTargetTopScrollPos = (target) => {
  // return target.offsetTop
  const rect = target.getBoundingClientRect()
  return rect.top + getWindowScrollTop()
}
// # go to target 
export const scrollToTarget = (target, offset = 0, callback = null, myTime = null) => {
  const targetTop = getTargetTopScrollPos(target) + offset
  // console.log(targetTop, offset, getTargetTopScrollPos(target))
  const time = myTime ? myTime : getScrollToTargetTime(target)
  // trace("***** scroll to target, time", time)
  TweenMax.to(window, time, {scrollTo: {y: targetTop}, ease: Power3.easeInOut, onComplete: callback});
}

const onScrollToClick = (e) => {
  e.preventDefault();
  const trigger = e.currentTarget
  const target = getAnchorLinkTarget(trigger)
  if (target) {
    const offset = trigger.dataset.offset ? parseInt(trigger.dataset.offset) : 0
    scrollToTarget(target, offset)
  }
}

// ### INIT
export const initCommon = () => {
  affixFafix()
  $(document).on('DOMContentLoaded load', windowUpdate);
  $(window).on('resize', windowUpdate);
  $('body').on('click', 'a[data-gallery]', onBlueimpGalleryLinkClick);
  $('body').on('click', '.scroll-to', onScrollToClick);
  $('body').on('click', '.print-me', (e)=> {
    e.preventDefault();
    window.print();
  });
  // window update
  windowUpdate();
};

